import React, {useEffect, useState, useRef, useMemo} from "react";
import {Button, Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import LanguageDropDown from "../LanguageDropDown/LanguageDropDown";
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import "./TopNav.css";
import Logo from "../../assets/images/lankalearners.png";
import {useDispatch, useSelector} from "react-redux";
import {logoutUser, clearForcedAuthModal} from "../../redux/userSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCrown, faRightFromBracket} from "@fortawesome/free-solid-svg-icons";
import AuthModalRHF from "../AuthModalRHF";
import LogoutModal from "../LogOutModal";

function getInitials(name, email) {
    const source = (name || email || "").trim();
    if (!source) return "U";
    const parts = source.split(" ").filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
}

export default function TopNav() {

    const userDetails = useSelector((state) => state?.user?.userDetails);
    const userId = useSelector((state) => state.user.userId);
    const isPro = useSelector((state) => state.user.isPro);
    const authModalForced = useSelector((state) => state.user.authModalForced);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const initials = useMemo(
        () => getInitials(userDetails?.name, userDetails?.email),
        [userDetails]
    );

    const [expanded, setExpanded] = useState(false);
    const [authModalOpen, setAuthModalOpen] = useState(false);
    const [showLogout, setShowLogout] = useState(false);
    const [learnOpen, setLearnOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(typeof window !== "undefined" && window.innerWidth >= 992);

    const closeTimeoutRef = useRef(null);
    const megaPanelRef = useRef(null);

    const handleAuth = () => {
        setAuthModalOpen(!authModalOpen)
    }

    const handleAuthModalClose = () => {
        setAuthModalOpen(false);
        if (authModalForced) dispatch(clearForcedAuthModal());
    };

    useEffect(() => {
        if (authModalForced) setAuthModalOpen(true);
    }, [authModalForced]);

    const LogOut = () => {
        localStorage.clear();
        sessionStorage.clear();
        dispatch(logoutUser());
        setShowLogout(false);
    };


    // useEffect(() => {
    //     const handleResize = () => {
    //         const desktop = window.innerWidth >= 992;
    //         setIsDesktop(desktop);

    //         if (!desktop) {
    //             setLearnOpen(false);
    //         }
    //     };

    //     handleResize();
    //     window.addEventListener("resize", handleResize);
    //     return () => window.removeEventListener("resize", handleResize);
    // }, []);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          megaPanelRef.current &&
          !megaPanelRef.current.contains(event.target)
        ) {
          setLearnOpen(false);
        }
      };

      if (learnOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [learnOpen]);

    const onAuth = async ({mode, email, password, name}) => {};

    const closeAll = () => {
        setExpanded(false);
        setLearnOpen(false);
    };

    const handleNavClick = () => {
        setExpanded(false);
        setLearnOpen(false);
    };

    const handleLearnClick = (e) => {
        if (!isDesktop) {
            e.preventDefault();
            setLearnOpen(!learnOpen);
        }
    };

    const handleCardClick = () => {
        // Close everything when clicking a card
        setLearnOpen(false);
        setExpanded(false);
    };

    return (
      <>
        <header className="ll-header">
          <Navbar
            expand="lg"
            expanded={expanded}
            className="ll-navbar"
            onToggle={(val) => setExpanded(val)}
          >
            <Container className="ll-container">
              {/* Logo */}
              <Navbar.Brand
                as={NavLink}
                to="/"
                onClick={closeAll}
                className="ll-brand"
              >
                <img src={Logo} alt="Lanka Learners" className="ll-logo" />
                LankaLearners.lk
              </Navbar.Brand>

              <Navbar.Toggle className="ll-toggle" aria-controls="ll-nav" />

              <Navbar.Collapse id="ll-nav">
                {/* Main Navigation */}
                <Nav className="ll-navlinks mx-auto">
                  <Nav.Link as={NavLink} to="/" end onClick={handleNavClick}>
                    Home
                  </Nav.Link>

                  {/* LEARN MEGA MENU */}
                  <NavDropdown
                    title="Learn"
                    id="learn-mega"
                    className="ll-mega"
                    show={learnOpen}
                    ref={megaPanelRef}
                    // onMouseEnter={() => {
                    //   if (isDesktop) {
                    //     if (closeTimeoutRef.current) {
                    //       clearTimeout(closeTimeoutRef.current);
                    //     }
                    //     setLearnOpen(true);
                    //   }
                    // }}
                    // onMouseLeave={() => {
                    //   if (!isDesktop) return;

                    //   closeTimeoutRef.current = setTimeout(() => {
                    //     if (
                    //       megaPanelRef.current &&
                    //       megaPanelRef.current.matches(":hover")
                    //     ) {
                    //       return;
                    //     }

                    //     setLearnOpen(false);
                    //   }, 300);
                    // }}
                    onToggle={(isOpen) => setLearnOpen(isOpen)}
                  >
                    <div
                      className="ll-megaPanel"
                      onClick={(e) => e.stopPropagation()}
                      onMouseLeave={() => isDesktop && setLearnOpen(false)}
                    >
                      <div className="ll-megaLayout">
                        <div className="ll-megaLeft">
                          <div className="ll-megaHead">
                            <div className="ll-megaTitle">Learn</div>
                            <div className="ll-megaDesc">
                              Study step-by-step with videos, papers, handbook
                              and traffic rules.
                            </div>
                          </div>

                          <div className="ll-megaGrid">
                            <NavLink
                              to="/driving-license-video-guide"
                              onClick={handleCardClick}
                              className="ll-megaCard"
                            >
                              <div
                                className="ll-cardIcon"
                                alt="Video Lessons for Driving licence trial Icon"
                              >
                                🎥
                              </div>
                              <div className="ll-cardTitle">Video Lessons</div>
                              <div className="ll-cardDesc">
                                Short lessons with clear explanations.
                              </div>
                            </NavLink>

                            <NavLink
                              to="/sri-lanka-driving-license-exam-papers"
                              onClick={handleCardClick}
                              className="ll-megaCard"
                            >
                              <div
                                className="ll-cardIcon"
                                alt="Driving licence test Papers Icon"
                              >
                                📝
                              </div>
                              <div className="ll-cardTitle">Past Papers</div>
                              <div className="ll-cardDesc">
                                Exam papers with answers & explanations.
                              </div>
                            </NavLink>

                            <NavLink
                              to="/driving-handbook"
                              onClick={handleCardClick}
                              className="ll-megaCard"
                            >
                              <div
                                className="ll-cardIcon"
                                alt="Driver's Handbook Icon"
                              >
                                📘
                              </div>
                              <div className="ll-cardTitle">
                                Driving Handbook
                              </div>
                              <div className="ll-cardDesc">
                                Read the official handbook with TOC.
                              </div>
                            </NavLink>

                            <NavLink
                              to="/traffic-rules-and-fines-sri-lanka"
                              onClick={handleCardClick}
                              className="ll-megaCard"
                            >
                              <div className="ll-cardIcon" alt="Traffic Rules Icon">🚦</div>
                              <div className="ll-cardTitle">Traffic Rules</div>
                              <div className="ll-cardDesc">
                                Rules, road signs, and key guidelines.
                              </div>
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </NavDropdown>

                  <Nav.Link
                    as={NavLink}
                    to="/find-and-register-driving-schools"
                    onClick={handleNavClick}
                  >
                    Learners
                  </Nav.Link>

                  <Nav.Link
                    as={NavLink}
                    to="/about-lanka-learners"
                    onClick={handleNavClick}
                  >
                    About
                  </Nav.Link>

                  <Nav.Link
                    as={NavLink}
                    to="/contact-lanka-learners"
                    onClick={handleNavClick}
                  >
                    Contact
                  </Nav.Link>
                </Nav>

                {/* Right Actions */}
                <div className="ll-actions">
                  {!userDetails?.email && !userId ? (
                    <Button
                      onClick={handleAuth}
                      className="ll-signin "
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "black",
                        fontWeight: 700,
                      }}
                      aria-label="Sign in"
                    >
                      Sign in
                    </Button>
                  ) : (
                    <NavDropdown
                      align="end"
                      id="ll-account-dropdown"
                      className="ll-accountDropdown"
                      title={
                        <span className="ll-accountToggle">
                          <span className="ll-avatar">{initials}</span>
                          <span className="ll-accountMeta">
                            <span className="ll-accountName">
                              {userDetails?.name || "My Account"}
                            </span>
                            {isPro && <span className="ll-proBadge">PRO</span>}
                          </span>
                        </span>
                      }
                    >
                      <NavDropdown.Item
                        onClick={() => navigate("/subscription")}
                      >
                        <FontAwesomeIcon icon={faCrown} className="me-2" />
                        {isPro ? "Manage Subscription" : "Upgrade to Pro"}
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item
                        onClick={() => setShowLogout(true)}
                        className="ll-logoutItem"
                      >
                        <FontAwesomeIcon
                          icon={faRightFromBracket}
                          className="me-2"
                        />
                        Logout
                      </NavDropdown.Item>
                    </NavDropdown>
                  )}

                  <div className="ms-2">
                    <LanguageDropDown />
                  </div>
                </div>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </header>

        <AuthModalRHF
          open={authModalOpen}
          onClose={handleAuthModalClose}
          onAuth={onAuth}
          initialMode="signin"
        />
        <LogoutModal
          onClose={() => setShowLogout(false)}
          show={showLogout}
          onConfirm={() => LogOut()}
          userDetails={userDetails}
        />
      </>
    );
}
